import { render, staticRenderFns } from "./SecurePDFViewer.vue?vue&type=template&id=43f7c8d0&scoped=true"
import script from "./SecurePDFViewer.vue?vue&type=script&lang=js"
export * from "./SecurePDFViewer.vue?vue&type=script&lang=js"
import style0 from "./SecurePDFViewer.vue?vue&type=style&index=0&id=43f7c8d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f7c8d0",
  null
  
)

export default component.exports